import React from 'react';

import { campaignShape } from '../../prop-types';
import AddProductForm from '../add-shared/AddProductForm';

const getMatchingProducts = (allProducts, productIds) =>
  allProducts.filter(product => productIds.includes(product.id));

function AddCountryForm(props) {
  return (
    <AddProductForm
      {...props}
      productFilter={getMatchingProducts}
      disablePricingUpdate
    />
  );
}

AddCountryForm.propTypes = {
  campaign: campaignShape.isRequired,
};

export default AddCountryForm;
